module.exports = __webpack_public_path__ + "img/logo-linker.c3af93a4.jpeg";